export default "__VITE_ASSET__kHeEk0AE__"